// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3viVk","footer":"Form_footer__3NUXw"};